import { Axios } from '@src/app/context/Api/includes/Axios';
import { translateAssignments, translateCriteria } from '@src/entities/ActionPath/includes/functions';
import { logger } from '@src/shared/includes/logger';
import { config } from '@uhg-abyss/web/tools/config';
import { isNil } from 'lodash';

/**
 * GetActionPath
 *
 * Retrieves a single action path from the remote API via an authenticated request.
 *
 * @param payload
 * @returns {Promise<any>}
 * @constructor
 */
export const GetActionPath = async (payload = {}) => {
  try {
    const theApiKey = payload?.[0];
    const theQueryKey = payload?.[1];
    const thePayload = payload?.[2];

    const requestArgs = {
      baseURL: config('API_URL'),
      headers: {
        'x-api-endpoint': `/action-paths/${thePayload?.actionPathId}`,
      },
      method: 'GET',
      params: { apiKey: theApiKey, queryKey: theQueryKey },
    };

    const remoteResponse = await Axios.request(requestArgs);

    if (!isNil(remoteResponse?.data?.criteria)) {
      remoteResponse.data.criteria = translateCriteria(remoteResponse?.data?.criteria, 'incoming');
    }

    if (!isNil(remoteResponse?.data?.assignments)) {
      remoteResponse.data.assignments = translateAssignments(remoteResponse?.data?.assignments, 'incoming');
    }

    return remoteResponse.data;
  } catch (error) {
    logger.error('src/entities/ActionPath/api/requests/queries/GetActionPath.js -> GetActionPath()', false, error);

    throw error;
  }
};
